<template>
  <div id="imageB">
    <div
      class="image-container"
      style="display: flex; justify-content: center; align-items: center"
    >
      <img
        class="zoomIn"
        width="400"
        height="400"
        v-bind:src="
          'https://ardunic-images.s3.eu-central-1.amazonaws.com/' + imageToShow
        "
      />
    </div>
    <hr />
    <div class="images-slid product-show mt-4 p-3">
      <Slider :options="productSlider">
        <img
          style="width: 100px"
          id="imageeeezz"
          v-for="(img, i) in item.images"
          @click="changeImage(img, i)"
          :key="i"
          width="100px"
          height="100px"
          :src="'https://ardunic-images.s3.eu-central-1.amazonaws.com/' + img"
        />
      </Slider>
    </div>
  </div>
</template>

<script>
import env from '@/assets/js/ENV.config.js';
import Slider from '@/components/Utilities/Share/Slider';
const {
  slider: { productSlider },
} = env;
export default {
  name: 'ImageBox',
  components: {
    Slider,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    productSlider,
  },
  data: () => {
    return {
      imageToShow: '',
    };
  },
  created() {
    this.imageToShow = this.item.images[0];
  },
  methods: {
    changeImage(newPath, index = 0) {
      this.item.images = this.item.images.map((path) => {
        if (path === this.imageToShow) return newPath;
        return path;
      });
      this.imageToShow = newPath;
    },
  },
};
</script>

<style scopped>
#imageeeezz {
  width: 100px;
  height: 100px;
}
</style>
